<template>
    <div>
        <ion-grid>
            <ion-row class="search-view">
                <ion-col size="3">
                    <ion-label>Branch Name</ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input class="form-input" readonly="true" v-model="branchDetails.branch" placeholder="branch name"/>
                    </div>
                </ion-col>
                <ion-col size="3">
                    <ion-label>Station Name</ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input class="form-input" readonly="true" v-model="branchDetails.stationName" placeholder="branch name"/>
                    </div>
                </ion-col>
                <!-- <ion-col size="3">
                    <ion-label>Select Station</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                            class="form-select select-mobile"
                            v-model="selectedStation"
                            @ionChange="changeStation($event)"
                            placeholder=""
                            interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(station, index) in stations" 
                            :key="index" 
                            :value="station.id"
                        >{{ station.name }}</ion-select-option>
                        </ion-select>

                        <select
                            v-model="selectedStation"
                            class="input-select select-web"
                            placeholder=""
                            @change="changeStation($event)"
                        >
                        <option
                            v-for="(station, index) in stations" 
                            :key="index" 
                            :value="station.id"
                        >{{ station.name }}</option>
                        </select>
                    </div>
                </ion-col> -->

                <ion-col size="3">
                    <ion-label>Select Charger Type</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                        class="form-select select-mobile"
                        v-model="selectedCharger"
                        @ionChange="changeCharger($event)"
                        placeholder="Select Report Type"
                        interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(charger, index) in chargers" 
                            :key="index" 
                            :value="charger.chargerId"
                        >{{ charger.chargerTypeDescription }}</ion-select-option>
                        </ion-select>

                        <select
                        v-model="selectedCharger"
                        class="input-select select-web"
                        placeholder="Select Status"
                        @change="changeCharger($event)"
                        >
                        <option
                            v-for="(charger, index) in chargers" 
                            :key="index" 
                            :value="charger.chargerId"
                        >{{ charger.chargerTypeDescription }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col size="3">
                    <ion-label>Select Output</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                        class="form-select select-mobile"
                        v-model="selectedOutput"
                        @ionChange="changeOutput($event)"
                        placeholder="Select Report Type"
                        interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(output, index) in outputs" 
                            :key="index" 
                            :value="output.outputId"
                        >{{ outputs.outputName }}</ion-select-option>
                        </ion-select>

                        <select
                        v-model="selectedOutput"
                        class="input-select select-web"
                        placeholder="Select Status"
                        @change="changeOutput($event)"
                        >
                        <option
                            v-for="(output, index) in outputs" 
                            :key="index" 
                            :value="output.outputId"
                        >{{ output.outputName }}</option>
                        </select>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row class="search-view" >
                <ion-col size="3">
                    <ion-label>From Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportFrom"
                        :typeable="true"
                        :lowerLimit ="sixMonthsAgo"
                        :upperLimit ="currentDate"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportFrom" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select From Date"
                        @change="fromDateChanged($event)"
                        :value = reportFrom
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        :typeable="true"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                <ion-col size="3">
                    <ion-label>To Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportTo"
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="maxDate"
                        :typeable="true"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportTo" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select To Date"
                        @change="reportTo = $event.target.value"
                        :value = reportTo
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                
                <ion-col size="3" v-if="displayDownloadOption">
                    <div class="export-report">
                        <ion-label style="font-size: 14px;">Export Report</ion-label>
                        <div class="border-line-34 margin-top-10">
                            <ion-select
                                class="form-select select-mobile"
                                :value="reportType"
                                @ionChange="changeReportType($event)"
                                placeholder="Export Report"
                                interface="action-sheet"
                            >
                                <ion-select-option
                                    v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</ion-select-option>
                            </ion-select>

                            <select
                                @change="changeReportType($event)"
                                class="input-select select-web"
                                v-model="reportType"
                                placeholder="Export Report"
                            >
                                <option
                                v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</option>
                            </select>
                        </div>
                    </div>
                </ion-col>
                <ion-col size="3">
                    <div class="btn-srch-clr">
                        <ion-button class="btn-search " @click="searchReport">Search</ion-button>
                        <ion-button class="btn-clear " @click="clearFields">
                            <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                    </div>
                </ion-col>
            </ion-row><br>
            
            <ion-row class="list-view" v-if="transactionReportDetails">
                <ion-col>
                    <ion-row class="list-head">
                        <ion-col size="3" size-md="1">
                        <ion-label>S. No</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>Inv.#</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>Inv.Date</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>Inv.Total</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>Time Completed</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>Reason</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="1">
                        <ion-label>kWh</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(report, index) in this.transactionReportData" :key="index">
                        <ion-col size="3" size-md="1">
                        <ion-label class="ext-link">{{ report.sNo }}</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>{{ report.invoiceNumber }}</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>{{ report.invoiceDate }}</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>{{ report.invoiceTotal}}</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>{{report.timeCompleted}}</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="2">
                        <ion-label>{{report.reason}}</ion-label>
                        </ion-col>
                        <ion-col size="3" size-md="1">
                        <ion-label>{{ report.totalkWh }}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="totalSection">
                        <ion-col size="9"></ion-col>
                        <ion-col size="2">
                            <ion-label>Total kWh </ion-label>
                        </ion-col>
                        <ion-col size="1"><ion-label>{{ totalkWh }}</ion-label></ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>

        <div>
            <ion-grid v-if="showGrid">
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="ion-text-center no-records">
                    <ion-label class="pagination-info txt-color">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row v-else>
                    <ion-col size="12" size-md="5">
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                       
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                    
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>        
</template>

<script>
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner} from "@ionic/vue";
import { defineComponent } from "vue";
import { receiptOutline, refresh } from 'ionicons/icons';
import datepicker from 'vue3-datepicker';
import moment from "moment";
import { ToastUtils } from "../../util/toast-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { migratedTryParseServiceError } from "../../service";
import { ValidationUtils } from "../../util/validation-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import jsonToCsvExport from "json-to-csv-export";

export default defineComponent({
    name: 'transactionReport',
    components:{
        IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonIcon, IonGrid, IonRow, IonCol, IonSpinner, IonButton, IonLabel, datepicker, IonInput, IonSelect, IonSelectOption
    },
    data(){
        return{
            receiptOutline,
            refresh,
            loaderTab: true,
            reportFrom: new Date(),
            reportTo: new Date(),
            configDays: 0,
            configMonths: 0,
            // Calculate the minimum and maximum dates
            // minDate: this.calculateMinDate(),
            maxDate: new Date(), // Current date
            // The current date
            currentDate: new Date(),
            // Date 6 months ago
            sixMonthsAgo: new Date(),
            pageData: [],
            norecordsfound: true,
            showGrid: true,
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            branchId: "",
            mobile: '',
            branchList: [],
            displayUserBasedReport: false,
            userBasedReport: [],
            overAllReport: [],
            transactionReportData: [],
            overAllPageData: [],
            reportTypes: [
                {
                    "name" : "PDF",
                    "code" : "pdf"
                },
                {
                    "name" : "CSV",
                    "code" : "csv"
                }
            ],
            reportType: "",
            displayDownloadOption: false,
            configValue: [],
            branchDetails: '',
            totalkWh: "",
            transactionReportOverAllData: "",
            transactionReportDetails: false,
            userRoleId: "",
            selectedStation: null,
            selectedCharger:"0",
            stations: [],
            chargers: [],
            outputs: [
                { outputId: "0", outputName: "All Outputs" }
            ],
            selectedOutput: "0",
            chargerName: "",
            outputName: ""
        }
    },
    async mounted() {
        this.userRoleId = window.localStorage.getItem("user.roleId");
        this.branchDetails = JSON.parse(localStorage.getItem('branchInfoFromReportList'));
        this.chargers = await new CorporateService().getChargerStatusDataForReport({
            branchId: this.branchDetails.branchId,
            stationId: this.branchDetails.stationId
        });
        if(this.chargers.length == 1) {
            this.selectedCharger = this.chargers?.[0]?.chargerId;
            this.chargers.filter((val) => {
                if(val.chargerId == this.selectedCharger) {
                    this.chargerName = val.chargerTypeDescription;
                }
            });
            this.outputs = await new CorporateService().getChargerOutputListForReport({
                branchId: this.branchDetails.branchId,
                stationId: this.branchDetails.stationId,
                chargerId: this.selectedCharger,
            });
            this.selectedOutput = this.outputs?.[0]?.outputId;
            this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    
                    this.outputName = val.outputName;
                }
            });
        } else {
            this.selectedCharger = this.chargers?.[0]?.chargerId;
            this.selectedOutput = this.outputs?.[0]?.outputId;
            this.chargers.filter((val) => {
                if(val.chargerId == this.selectedCharger) {
                    this.chargerName = val.chargerTypeDescription;
                }
            });
            this.outputs.filter((val) => {
                
                if(val.outputId == this.selectedOutput) {
                    
                    this.outputName = val.outputName;
                }
            });
        }
        await this.getDateAndMonth()
        await this.getDateDaysAgo(this.configDays)
        await this.getDateMonthsAgo(this.configMonths)
        await this.searchReport();
    },
    
    methods: {
        changeStation(event) {
            this.selectedStation = event.target.value;
        },
        async changeCharger(event) {
            this.selectedCharger = event.target.value;
            this.chargers.filter((val) => {
                if(val.chargerId == this.selectedCharger) {
                    
                    this.chargerName = val.chargerTypeDescription;
                }
            });
            this.outputs = await new CorporateService().getChargerOutputListForReport({
                branchId: this.branchDetails.branchId,
                stationId: this.branchDetails.stationId,
                chargerId: this.selectedCharger,
            });
            this.selectedOutput = this.outputs?.[0]?.outputId;
            this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    this.outputName = val.outputName;
                }
            });
            this.transactionReportDetails = false;
            this.displayDownloadOption = false;
            this.showGrid = false;
        },
        changeOutput(event) {
            this.selectedOutput = event.target.value;
            this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    this.outputName = val.outputName;
                }
            });
            this.transactionReportDetails = false;
            this.displayDownloadOption = false;
            this.showGrid = false;
        },
        async getDateAndMonth() {
            this.configValue = await new CorporateService().getConfigValueOfDateAndMonth()
            this.configDays = this.configValue[0].description;
            this.configMonths = this.configValue[1].description
        },
        calculateMinDate() {
            const date = new Date();
            date.setMonth(date.getMonth() - 6);
            return date;
        },
        fromDateChanged(event) {
            // alert(event)
        },
        // Helper function to calculate a date 'n' days ago
        async getDateDaysAgo(days) {
            const date = new Date();
            date.setDate(date.getDate() - days);

            this.reportFrom =  date;
        },

        // Helper function to calculate the date 'n' months ago
        async getDateMonthsAgo(months) {
            const date = new Date();
            date.setMonth(date.getMonth() - months);
            this.sixMonthsAgo = date;
        },
        changeDateFormat(dateValue) {
            // return moment(dateValue).format('DD/MMM/YYYY HH:mm')
            return dateValue;
        },
        async changeBranchName(event) {
            this.branchId = event.target.value;
        },
        async searchReport() {
            this.showGrid = true
            this.loaderTab = true;
            this.pageNo = 1;
            this.pageRecords = 10;
            this.reportType = "";
            this.displayDownloadOption = false;
            let dateRange =  (new Date(this.reportTo) - new Date(this.reportFrom));
            let dateRangeBetween = dateRange/(1000*60*60*24)
            if(this.reportFrom &&
                this.reportTo &&
                new Date(this.reportFrom) > new Date(this.reportTo)){
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select correct date range of Reoprt. From date should less than To date");
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else if(dateRangeBetween > this.configDays) {
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select valid date range. The report can be viewed for a maximum of "+ this.configDays + " days");
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else {
                try {
                    this.transactionReportOverAllData = await new CorporateService().getTransactionAndStatusReportQuery({
                        branchId: this.branchDetails.branchId,
                        reportCode: this.branchDetails.reportCode,
                        reportId: this.branchDetails.reportId,
                        fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                        toDate: moment(this.reportTo).format('YYYY-MM-DD'),
                        branchName: this.branchDetails.branch,
                        stationName: this.branchDetails.stationName,
                        stationId: this.branchDetails.stationId,
                        chargerId: this.selectedCharger,
                        outputId: this.selectedOutput,
                        chargerType: this.chargerName,
                        outputName: this.outputName,
                    });
                    this.totalkWh = this.transactionReportOverAllData.totalKwh;
                    if(this.transactionReportOverAllData.reportData.length > 0) {
                        this.totalRecords = this.transactionReportOverAllData.reportData.length;
                        (this.pagesList = new PaginationUtils().getPagesList(
                        this.totalRecords,
                        this.pageRecords,
                        this.pageNo
                        )),
                        (this.totalPages = new PaginationUtils().getTotalPages(
                            this.totalRecords,
                            this.pageRecords
                        ));
                        let to = this.pageRecords*this.pageNo;
                        let from = (this.pageRecords * (this.pageNo -1));
                        this.transactionReportData = this.transactionReportOverAllData.reportData.slice(from, to)
                        this.transactionReportDetails = true
                        this.displayDownloadOption = true;
                        this.norecordsfound = false;
                    } else {
                        this.transactionReportDetails = false;
                        this.norecordsfound = true;
                        this.displayDownloadOption = false;
                    }
                    this.loaderTab = false;
                } catch(error) {
                    this.loaderTab = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }              
                
            }
        },
        async changeReportType(event) {
            let type = event.target.value;
            if(type == 'pdf') {
                this.downloadPdf(this.transactionReportOverAllData)
            } else if(type == 'csv') {
                this.downloadCSV(this.transactionReportOverAllData)
            }
        },
        async downloadCSV(reportDate) {
            if(this.userRoleId == 1 || this.userRoleId == 4) {
                try {
                // console.log(JSON.stringify(reportDate))
                    jsonToCsvExport({ data: reportDate.downloadingReportData.csv,headers: reportDate.reportHeaders.csvHeader, filename: "TransactionReport_"+moment().format("DD/MM/YYYY")+".csv" })  // Automatically triggers download
                    this.reportType = ""
                } catch (error) {
                    console.error('Error generating CSV:', error);
                }
            } else {
                new ToastUtils().presentToast("You cannot download the reports");
            }
            
        },
        async downloadPdf(data) {
            if(this.userRoleId == 1 || this.userRoleId == 4) {
                try {
                    this.loaderTab = true;
                    const response = await new CorporateService().downloadUsagePdfReport(data, this.branchDetails.branchId, this.branchDetails.reportCode);
                    // Create a URL for the blob (PDF file)
                    const pdfBlob = response.data;
                    const pdfUrl = window.URL.createObjectURL(pdfBlob);
                    var a = document.createElement("a");
                    a.href = pdfUrl;
                    a.setAttribute("download", "TransactionReport_"+moment().format("DD/MM/YYYY")+".pdf");
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    this.loaderTab = false;
                    this.reportType = ""
                } catch(error) {
                    this.loaderTab = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            } else {
                new ToastUtils().presentToast("You cannot download the reports");
            }
            
        },
        async clearFields() {
            this.reportTo = new Date();
            if(this.mobile){
                document.getElementById("mobile").value = null;
                this.mobile = "";
                await this.getDateDaysAgo(this.configDays)
                await this.getDateMonthsAgo(this.configMonths)
                this.selectedCharger = "0";
                this.selectedOutput = "0";
                this.chargerName = "All Charger Type"
                this.outputName = "All Outputs"
                this.outputs = [{ outputId: "0", outputName: "All Outputs" }];
                this.searchReport();
                this.reportType = "";
                
            }else {
                await this.getDateDaysAgo(this.configDays)
                await this.getDateMonthsAgo(this.configMonths)
                this.selectedCharger = "0";
                this.selectedOutput = "0";
                this.chargerName = "All Charger Type"
                this.outputName = "All Outputs"
                this.outputs = [{ outputId: "0", outputName: "All Outputs" }];
                this.searchReport();
                this.reportType = "";
            }
            
        },
        async loadPage(page) {
            // localStorage.setItem("cpoReservationPage", page);
            // alert(page+ "--"+this.totalRecords+"--"+this.pageRecords)
            this.loaderTab = true;
            this.pageNo = page;
            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                page
            );
            let to = this.pageRecords*page;
            let from = (this.pageRecords * (page -1));            
            this.transactionReportData = this.transactionReportOverAllData.reportData.slice(from, to);
            this.loaderTab = false;
        },
    },
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
.btn-srch-clr{
    margin-top: 22px;
}
.export-report{
    /* width: 50%; */
}
.totalSection{
    /* background-color: #ededed; */
    margin-top: 20px;
    font-weight: bold;
}
.ext-link{
    color: black;
    cursor: auto;
}
.no-records{
    margin-top: 100px;
}
.txt-color{
    font-size: 16px;
}
</style>
